import React from "react";
import styled from "styled-components";

export const IconContainer = styled.span<{
  $isInteractive?: boolean;
  $isInline?: boolean;
  $height: React.CSSProperties["height"];
  $margin: React.CSSProperties["margin"];
  $verticalAlign: React.CSSProperties["verticalAlign"];
}>`
  display: ${({ $isInline }) => ($isInline ? "inline-flex" : "flex")};
  cursor: ${({ $isInteractive }) => ($isInteractive ? "pointer" : "inherit")};
  height: ${({ $height }) => $height};
  margin: ${({ $margin }) => $margin};
  vertical-align: ${({ $verticalAlign }) => $verticalAlign};
  &:hover {
    opacity: ${({ $isInteractive }) => ($isInteractive ? 0.8 : 1)};
  }
`;

export const IconElement = styled.span<{
  $name: string;
  $color?: string;
  $size: string;
}>`
  display: inline-flex;
  background-color: ${({ $color, theme }) => $color || theme.colors.primary};
  -webkit-mask: url("${({ $name }) => `/icons/${$name}.svg`}") no-repeat center;
  mask: url("${({ $name }) => `/icons/${$name}.svg`}") no-repeat center;
  -webkit-mask-size: ${({ $size }) => $size};
  mask-size: ${({ $size }) => $size};
  width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
`;
